import { IconSVG } from '../types';

export const PhoneHorizontal = ({ size, style }: IconSVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 55 55"
    style={style}
  >
    <path
      fill="currentColor"
      d="M1.145 16.746q0-1.736 1.203-2.94 1.203-1.202 2.94-1.202h39.839q1.735 0 2.94 1.203 1.202 1.203 1.203 2.94v21.505q0 1.737-1.204 2.94t-2.94 1.203H5.288q-1.735 0-2.94-1.203-1.202-1.203-1.202-2.94zm10.84-.705H5.288a.67.67 0 0 0-.485.22.67.67 0 0 0-.22.485v21.506q0 .265.22.485t.485.22h6.699zM6.258 27.499q0 .842.593 1.435.592.592 1.434.592t1.434-.592q.594-.593.593-1.435 0-.84-.592-1.434a1.95 1.95 0 0 0-1.435-.593q-.842 0-1.434.593a1.95 1.95 0 0 0-.593 1.434m9.166-11.458v22.917H39.53V16.04zm27.544 0v22.917h2.16a.67.67 0 0 0 .485-.22.67.67 0 0 0 .22-.486V16.746a.67.67 0 0 0-.22-.485.67.67 0 0 0-.485-.22z"
    />
  </svg>
);

export default PhoneHorizontal;
